var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"icon":"el-icon-star-on","type":"text"},on:{"click":_vm.godesign}},[_vm._v("设计模式")]),_c('el-button',{attrs:{"icon":"el-icon-star-on","type":"text"},on:{"click":_vm.goview}},[_vm._v("查看模式")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }